import React, { useEffect, useState } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';
import { wsPost } from 'services/WService';

function AddSellerModal(props) {
  const { model, setOpen, showNotify } = props;
  const [sellers, setSellers] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState();
  const [selectedBureau, setSelectedBureau] = useState();

  async function listBureaus(baseZoneId) {
    let res = await wsGetAll(`base/bureau?base_zone_id=${baseZoneId}`);
    if (res.success) {
      setBureaus(res.data);
    }
  }

  async function listSellers(baseRouteId) {
    let res = await wsGetAll(`base/route/${baseRouteId}/sellers`);
    if (res.success) {
      setSellers(res.data);
    }
  }

  useEffect(() => {
    if (model.routeQuota === undefined) return;
    listSellers(model.routeQuota.route.id);
    listBureaus(model.routeQuota.route.base_zone_id);
  }, [model.routeQuota]);

  async function onSubmit() {
    let res = await wsPost(`quota/route/${model.routeQuota.id}/seller`, {
      base_bureau_id: selectedBureau,
      base_seller_id: selectedSeller,
      quota: 0,
    });

    if (res.success) {
      model.setSellerQuotas((sellerQuotas) => {
        let newSellerQuotas = [...sellerQuotas];
        newSellerQuotas.push(res.data);
        newSellerQuotas = newSellerQuotas.sort(
          (first, second) => parseInt(first.seller.SlpCode) - parseInt(second.seller.SlpCode),
        );
        console.log(newSellerQuotas);
        return newSellerQuotas;
      });
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
      throw Error('Error xd');
    }
  }

  return (
    <Modal
      title={`Agregar vendedor`}
      model={model}
      setOpen={() => {
        setOpen({ open: false });
      }}
      onSubmit={onSubmit}
      entity=""
    >
      <GridContainer>
        <GridItem xs={12}>
          <TextField
            label="Ruta"
            fullWidth
            value={model.routeQuota?.route?.description || ''}
            disabled
          />
        </GridItem>
        <GridItem xs={12}>
          <TextField
            label="Marca"
            fullWidth
            value={model.routeQuota?.mark?.description || ''}
            disabled
          />
        </GridItem>

        <GridItem xs={12}>
          <Autocomplete
            options={sellers}
            value={sellers.find((seller) => seller.id === selectedSeller) || null}
            getOptionLabel={(option) => `${option.SlpName} (${option.SlpCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Vendedor" margin="normal" required />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setSelectedSeller(item.id);
              }
              setSelectedSeller(undefined);
            }}
          />
        </GridItem>

        <GridItem xs={12}>
          <Autocomplete
            options={bureaus}
            value={bureaus.find((bureau) => bureau.id === selectedBureau) || null}
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField {...params} label="Mesa" margin="normal" required />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setSelectedBureau(item.id);
              }
              setSelectedBureau(undefined);
            }}
          />
        </GridItem>
      </GridContainer>
    </Modal>
  );
}

export default AddSellerModal;
